module.exports = {
    user:{
        announcement: '선언',
		userCenter: '사용자 센터',
		langSetting: '언어 설정',
		securityCenter: '안전 센터',
		versionUpdates: '버전 갱신',
		monetaryUnitSetting: '화폐단위설정',
		currencySet: '화폐 종류 설정',
		aboutUs: '우리에 대하여',
		share: '우리와 함께',
		loginRegister: '로그인/등록',
		logout: '로그 아웃 로그인'
	},
	// 首页
    home:{
        performer:'상승폭 순위',
		DropList:'낙폭 차트',
		transferAccounts:'이체',
		ExpertsToShare:'전문가 공유',
		service:'콜',
		share:'나누다',
		SaveMoneyLive:"저금 하여 생활하다",
		CurrencyTraders:'폐 업자',
		experienceImmediately:'즉시 체험하다',
		shares:'로그인 후 에야 공유 가능 합니다',
		copysuc:'링크 공유 복제 성공',
		nonsupport:'이 브라우저는 자동으로 복사하는 것을 지원 하지 않습니다'
	},
	// tab栏
    footer: {
		home: '메인',
		news: '뉴스',
		market: '시세',
		deal: '교역',
		wallet: '지갑',
		c2c: 'C2C'
	},
	// 行情
    market: {
		currency: '화폐의 종류',
		price: '가격',
        increase: '상승폭',
        market:'시세',
		optionalArea:'자기 선거구',
		loadingLoad:'불러오는 중',
		noData:'아직 무수 한 증거',
		"LIMIT_TRADE_BTC": "최소 거래0.001BTC",
		"LIMIT_TRADE_C2C": "최소 거래70元",
		"LIMIT_TRADE_ETH": "최소 거래0.01ETH",
		"LIMIT_TRADE_USDT": "최소 거래10USDT",
		"LIMIT_TRADE": "소액 주문서 금지"
	},
	// 钱包
    wallet: {
		myWallet: '내 지갑',
		toLogin: '조작 지갑에 로그인',
        noLogin: '아직 등록 안 했 네요~',
        assetValuation:'자산 평가 액',
		enter:'입력 한 화폐 종류의 명칭을 실시간으로 여과 한다',
		usable:'사용가능한',
		lock:'잠금',
		Recharge:'채워넣다',
		MentionMoney:'티 머 니',
		deal: '교역',
		transferAccounts:'이체',
	},
	// 交易
    buy:{
		price:'가격',
		amount:'수량',
		rental:'총액',
		availableBalance:'사용 가능 한 잔고:',
		AllWarehouse:'전 창',
		AWarehouse:'반 창',
		warehouse:'창',
		buy:'매입하다',
		sale:'매출하다',
		TransactionsAreNotAllowedInThisCurrency:'이 화폐 종류는 거래를 허락 하지 않는다',
		sell:'팔다',
		purchase:'사다',
		type:'유형',
		turnover:'거래 수량',
		hint:'힌트',
		confirm:'확정하다',
		cancel:'취소하다',
		CommissionedByTheCurrent:'현재 위탁',
		BidHistory:'거래 기록'
	},
	// 登录
    login: {
		login: '로그인',
		safe:'안전하고 믿을만 한 디지털 화폐 거래 플랫폼',
		inputmobile:'메일이나 핸드폰 번호를 입력 하세요',
		inputpass:'비밀번호를 입력하십시오',
		input:'입력하십시오',
		authcode:'인증번호',
		getcode:'인증 번호 가져오기',
		second:'까끄라기',
		forgets:'비밀번호를 잊어 버렸으면, 바 랍니다',
		getpass:'비밀번호 찾기',
		register :'등록 계좌 번호',
		machine:'사람과 기계의 검증을 클릭 하세요',
		land:'로그인 중...',
		"ACCOUNT_HAS_BEEN_DISABLED": "계정이 금지 되다",
		"DISABLE_LOGIN": "로그인 금지",
		"TOO_MANY_INCORRECT_LOGIN_PASSWORD": "로그인 비밀번호에 오류 가 너무 많이 발생 했습니다. 10분 후에 다시 시도하십시오",
		"GOOGLE_AUTHENTICATION_CODE_ERROR": "Google 인증 번호 오류",
		"USER_DOES_NOT_EXIST": "사용자 존재 하지 않 음",
		"ACCOUNT_OR_PASSWORD_IS_INCORRECT": "계정 또는 비밀번호 가 잘못 되었습니다",
		"PLEASE_RE-VERIFY": "재검증 바 랍니다"
	},
	// 找回密码
	forgot:{
		retpass:'비밀번호 찾는 중',
		inputcorrect:'정확 한 메일이나 핸드폰 번호를 입력 하세요',
		inputnull:'메일이나 핸드폰 번호를 입력 하세요',
		inputcode:'인증 번호를 입력하십시오',
		newpass:'새 암호',
		passnull:'비밀번호 가 비어 있지 않습니다',
		chars:'8-16 개의 공백 문자를 입력하십시오',
		surepass:'비밀번호 확인',
		againpass:'비밀번호를 다시 입력 해 주세요',
		nopass:'비밀번호 입력이 두 번 일치 하지 않습니다',
		forgots:'비밀번호 찾기',
		changepass:'비밀번호 변경에 성공하였습니다.',
		perfect:'완벽 한 정보 부탁 드 립니다.'
	},
	// 注册
	sign:{
		signs:'새 회원 계정을 등록하다',
		name:'사용자 닉네임을 입력하십시오',
		signaccount:'등록 계정',
		send:'송출하다',
		codenull:'인증 번호를 입력하십시오',
		setpass:'로그인 비밀번호를 설정하십시오',
		referrer:'추천인 (필 필이아 닌 사람)',
		mustreferrer:'추천인(필이아 닌 사람)'
	},
	// c2c交易
    c2c: {
        "PLEASE_VERIFY_YOUR_REALNAME": "먼저 실명 인증 해주세요",
        deal:'교역',
		tradingRecord:'거래 기록',
		need:'필요하다',
		ToBuyImmediately:'바로 사다',
		acquirability:'학점',
		ImmediatelySell:'즉시 팔다',
		purchases:'매입 량',
		BuyQuantity:'매입 수량',
		SellQuantity:'매출 량',
		TradeShow:'매매 설명',
		buying:'매매 자는 모두 현지 답사 인증 상인을 위해 서 이며, 100만 USDT 보증금을 제공 합니다. 당신은 환전 할 때마다 상가의 자산을 동결하고, 부족 할 때는 주문을 받을 수 없 으니 안심하고 바 꿀 수 있습니다',
		cashDeposit:'매매 자는 모두 실명 인증 상인에게 보증금을 제공하 며 안심하고 환전 할 수 있다',
		alipay:'본인이 바인딩 한 카드로 입금 해주 시고 다른 어떤 방식으로든 환불 해주세요.(위 챗과 지불 금지)',
		processingTime:'취급 시간 9:00-21:00 처리 시간이아 닌 주문은 다음 날 9:00으로 처리 되 며 보통 주문서 받은 후 24 시간 내에 완료 됩니다',
		toDay:'단 하루 최대 5 건의 미 처리 충전 수주。',
		unitPrice:' 단가',
		paymentInformation:'지급 정보',
		moneyOrder:'송금 영수증',
		success:'성공',
		canceledCanc:'취소 됨',
		inhand:'처리 중',
		haveExpired:'만료 됨',
		unpaid:'지불 대기',
		name:'수납 창구의 상호',
		oBnak:'돈을 받는 쪽에서 계좌를 개설하다',
		number:'수납 창구 계좌 번호',
		txt:'송금 할 때 메모 내용',
		must:'(부디 기입 해 주십시오)',
		mobile:'수신 자의 휴대전화 번호',
		HaveTransfer:'이체 됨',
		cancel:'주문 취소',
		back:'되돌아가다',
		CancelWithdrawal:'현금 인출을 취소하다',
		ToTransfer:'대체 계정',
		overdue:'이월',
		service:'서비스 업체 이름',
		snum:'서비스업체 핸드폰 번호',
		tacount:'대체 금액',
		state:"상태",
		ordercancel:'주문 취소 됨',
		orderdispose:'주문서 처리 했습니다',
		copysuccess:'성공적으로 복제 됨',
		surecancel:'확실히 취소 하시겠습니까?',
		depositsuccess:'현금 인출에 성공 하니, 서비스업체의 처리를기다 려 주십시오?',
		untreated:'처리 되지 않 음'
	},
	// 安全中心
    security:{
		LoginPasswordSetting:'로그인 비밀번호 설정',
		Certification:'실명인증',
		GoogleCertification:'구 글 인증',
		PaymentOfTheBinding:'지급 바인딩',
		verificationMode:'인증 방식',
		BindingMobilePhone:'휴대 전화'
	},
	// 密码验证
    password:{
		changePassword:'비밀번호 변경',
		PleaseEnterANewPassword:'새로 운 암호를 입력하십시오',
		ConfirmNewPassword:'새 비밀번호 확인',
        resetPasswords:'비밀번호 초기화',
        passwordCannot:'비밀번호는 8 자리 이상이어야 합니다',
		DifferentPasswords:'비밀번호 가 다르다',
		passwordEmpty:'비밀번호 가 비어 있지 않습니다'
    },
    // 实名认证
	certification:{
		Certification:'실명인증',
		Credentials:'인증 정보 기입 하기 (중국 대륙)',
        hint:'따스 한 제시:본인의 진실 한 신분을 확인 하여 계좌와 자금 조작의 안전을 보장하고 개인정보의 안전을 보호 하여 주십시오',
        realNames:'당신의 실명을 입력하십시오',
		validID:'유효 신분증 번호',
		uploading:'증명 정보 업로드 (선명하게 보이기 위해 서)',
		frontCard:'신분증 앞면 (사례 보기)',
		versoCard:'신분증 뒷면 (사례 보기)',
		handCard:'손에 신분증을 휴대하다 (예제를 살펴보다)',
		signature:'손에 본인 신분증 정면 사진과 개인 서명 (당신은 신분증을들고 정면 사진과 개인 서명 사진을 한 장 올 려 주세요. 개인 서명의 내용이 포함 되어 있습니다',
		submit:'인증 제출',
		AuditFailed:'심사에서 통과 되지 않다',
		cause:'원인',
		revalidate:'재검증',
		audit:'실명 확인 중......',
		pass:'당신은 이미 실명 인증을 거 쳤습니다',
		frontCardFailToUpload:'신분증을 정면으로 올리 는데 실패 했습니다',
		versoCardFailToUpload:'신분증 뒷면에 올 릴 수 없습니다',
		handCardFailToUpload:'신분증을 가지고 업로드하 는데 실패 했습니다',
		realName:'실명을 입력 해 주세요',
		IDCard:'주민등록번호를 입력하십시오',
		await:'업로드를 기다리는 중',
		submitSuccessfully:'성공적으로 보내기'
	},
	// 谷歌认证
	Google:{
		authentication:'법학',
		copy:'복제',
		gcode:'구 글 인증 번호를 입력하십시오',
		gopen:'Google 인증 열기',
		turned:'검색을 시작 했습니다',
		change:'변경하다',
		gvcode:'구 글 검증 코드',
		gcancel:'구 글 인증 취소',
		gnull:'구 글 인증 번호 가 비어 서는 안 됩니다',
		pnull:'비밀번호 가 비어 있지 않습니다',
		gerr:'구 글 인증 번호 오류',
		perr:'암호 오류'
	},
	// 支付绑定
	pay:{
		Payment:'지급 바인딩',
		deposit:'계좌 개설 은행',
		bCard:'은행 카드 번호',
		change:'고치다',
		confirm:'확정하다'
	},
	// 验证方式
	vmode:{
		vmode:'인증 방식',
		Passauth:'암호 인증',
		gauth:'구 글 인증',
		eauth:'메일 인증 서',
		mauth:'메시지 확인'
	},
	// 绑定手机
	bmobile:{
		bmobiles:'휴대 전화',
		mnumber:'휴대폰번호',
		pnum:'핸드폰 번호를 입력 해 주세요',
		mauth:'문자 인증 번호',
		gcode:'인증 번호 가져오기',
		again:'초 후에 다시 가져오기',
		unbind:'끄르다 묶',
		submit:'내다'
	},
	// 搜索
	search:{
		antistop:'키워드를 입력하십시오',
		search:'검색하다'
	},
	// 关注货币
	currency:{
		attention:'관심을 가 진 화폐의 종류',
		noattention:'관심 없는 통화',
		currencyname:'입력 한 화폐 종류의 명칭을 실시간으로 여과 한다',
		acurrency:'관심을 갖는 화폐 종류',
		kind:'인종'
	},
	// 身份验证
	showDialogs:{
		authentication:"인증",
		password:'암호',
		ppass:'비밀번호를 입력하십시오',
		gauth:'구 글 검증 코드',
		pgauth:'구 글 인증 번호를 입력하십시오',
		eauth:'메일 인증 번호',
		peauth:'메일 인증 번호를 입력하십시오',
		mauth:'핸드폰 인증 번호',
		pmauth:'휴대전화 인증 번호를 입력 하세요',
	},
	// 提币
	withdrawto:{
		address:'주소 이름, 예를들면,나의 주소 1, 선택 기재',
		depositprice:'현금 인출 금액',
		inputprice:'금액을 입력하십시오',
		usableprice:'사용 가능 한 잔고:',
		mindeposit:'최저 현금 인출:',
		commissionCharges:'수수료.',
		sure:'잡다',
		deposit:'티 머 니',
		or:'혹',
		taccounts:'당좌이체',
		pinput:'입력하십시오',
		depositadd:'현금 인출 주소',
		raccount:'상대방 계좌',
		depositsuccess:'현금 인출에 성공하다.',
		addnull:'주소나 현금 인출 금액이 비어 서는 안 됩니다',
		passerr:'암호 오류',
		gerr:'구 글 인증 번호 오류'
	},
	// 充值
	payto:{
		qrcode:'2 차원 (주) 소까지 충분하다',
		copy:'복제',
		sweepcode:'이차원 코드를 점검 해보다',
		getadd:'충전 소를 얻다',
		inputrecharge:'충전 액을 입력하십시오',
		sure:'확인하다',
		hint:'충전 할 금액을 입력하고, 충분 한 자금이 있는 대리 상을 려과 합니다. (아래 연락처를 통해 대리 상에게 연락 하여 충전 합니다.)',
		Rechargedefeated:'충전 실패',
	},
	// 充值提现记录
	bill:{
		record:'충전 가치 인출 기록',
		allrecord:'모든 기록',
		rechargeRecord:'충전 기록',
		withdrawRecord:'현금 인출 기록',
		ToAudit:'심사를 기다리다',
		error:'착오',
		pulldown:'다음 보기 더 보기',
		nodata:'더 이상의 데이터 가 없습니다.',
		loading:'불러오는 중...'
	},
    "ACCOUNT_HAS_BEEN_DISABLED": "계정이 금지 되다",
	"DISABLE_LOGIN": "로그인 금지",
	"TOO_MANY_INCORRECT_LOGIN_PASSWORD": "로그인 비밀번호에 오류 가 너무 많이 발생 했습니다. 10분 후에 다시 시도하십시오",
	"GOOGLE_AUTHENTICATION_CODE_ERROR": "Google 인증 번호 오류",
	"USER_DOES_NOT_EXIST": "사용자 존재 하지 않 음",
	"ACCOUNT_OR_PASSWORD_IS_INCORRECT": "계정 또는 비밀번호 가 잘못 되었습니다",
	"PLEASE_RE-VERIFY": "재검증 바 랍니다",
	"PLEASE_VERIFY_YOUR_REALNAME": "먼저 실명 인증 해주세요",
	"USER_NAME_TAKEN": "사용자 이름이 이미 사용 중 입니다",
	"MOBILE_EXISTS": "핸드폰 번호 가 이미 존재 합니다",
	"EMAIL_EXISTS": "메일 박스 가 이미 존재 함",
	"CODE_HAS_SEND": "인증 번호 가 발송 되었으니 확인 하시고 받 으세요",
	"THE_PASSWORD_MUST_NOT_BE_LESS_THAN_8_BITS": "비밀번호는 8 자리 이상이어야 합니다",
	"PARAMETER_ERROR": "규범에 맞지 않다",
	"VERIFICATION_CODE_ERROR": "인증 번호 오류",
	"INVALID_EMAIL": "잘못된 메일 주소",
	"EMAIL_TAKEN": "메일 박스 가 이미 사용 중 입니다",
	"MOBILE_TAKEN": "핸드폰 번호 가 이미 사용 되었습니다",
	"INVALID_SMS_CODE": "인증 번호 오류",
	"INVALID_NUMBER": "잘못된 핸드폰 번호",
	"INVALID_CAPTCHA": "잘못된 인증 번호 입니다",
	"ACCOUNT_ERROR": "계정 오류",
	"BALANCE_NOT_ENOUGH": "잔고 가 부족하다",
	"SUCCESS": "성공",
    "PERMISSION_DENIED":"권한 부족",
    "OPERATION_TOO_FAST": "조작이 너무 빠르다",
}



// WEBPACK FOOTER //
// ./src/common/language/ko.js